import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/discuss/canvas-send-active.png';
var _hoisted_1 = {
  key: 0,
  class: "top"
};
var _hoisted_2 = {
  class: "list"
};
var _hoisted_3 = {
  class: "info"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "name"
};
var _hoisted_6 = {
  class: "date"
};
var _hoisted_7 = {
  class: "content"
};
var _hoisted_8 = {
  key: 1,
  class: "send"
};
var _hoisted_9 = ["src"];
import { ref, reactive, computed, watch, onMounted, inject } from 'vue';
import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
import { getStore } from '@/util/store';
import { operationRecord } from '../common';

/* api */
import { getFileAnnocation, getCourseAnnocation, addFileAnnocation, addCourseAnnocation, delFileAnnocation, delCourseAnnocation, delFileAnnocationList, delCourseAnnocationList } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'NoteList',
  props: {
    pointId: {
      type: String,
      default: ''
    },
    ownerId: {
      type: [String, Number],
      default: ''
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'delPoint'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */
    var userInfo = getStore({
      name: 'userInfo'
    });
    var userId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id;
    var discussId = inject('discussId');
    var annotationType = inject('annotation-type'); // 在哪个页面批注
    var annotationInfo = inject('annotation-info'); // 页面带来的批注所需信息
    var annotationRoleId = inject('annotation-roleId'); // 页面当前视角id
    var emit = __emit;
    var props = __props;
    var textareaRef = ref();
    var state = reactive({
      list: [],
      content: ''
    });
    var defaultAvatar = require('@/assets/discuss/default-avatar.png');

    /* 计算属性 */
    var isMinePoint = computed(function () {
      return props.ownerId === userId;
    });
    var isMineCanvas = computed(function () {
      return annotationRoleId.value === userId;
    });

    /* 监听 */
    watch(function () {
      return props.pointId;
    }, function () {
      getList();
    });

    /* 事件 */
    // 输入事件
    var handleInput = function handleInput(e) {
      state.content = e.target.innerText;
    };

    // 发送评论
    var handleSend = function handleSend() {
      if (!state.content) {
        MessagePlugin.warning('请输入内容！');
        return;
      } else if (state.content.length > 300) {
        MessagePlugin.warning('内容最多300字！');
        return;
      }
      var data = {
        discussId: discussId.value,
        viewerId: annotationRoleId.value,
        pointId: props.pointId,
        annocationUserId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id,
        annocationName: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
        annocationContent: state.content,
        annocationAvatar: userInfo === null || userInfo === void 0 ? void 0 : userInfo.avatar
      };
      var apiPromise = null;
      if (annotationType === 'file') {
        data.documentId = annotationInfo.value.id;
        data.documentItemId = annotationInfo.value.imgId;
        apiPromise = addFileAnnocation(data);
      } else if (annotationType === 'course') {
        data.courseResearchId = annotationInfo.value.courseId;
        apiPromise = addCourseAnnocation(data);
      }
      apiPromise.then(function (res) {
        if (res.data.code === 0) {
          MessagePlugin.success('评论成功！');
          state.content = '';
          textareaRef.value.innerText = '';
          getList();
        }
      });
    };

    // 获取评论列表
    var getList = function getList() {
      var params = {
        discussId: discussId.value,
        pointId: props.pointId
      };
      var apiPromise = null;
      if (annotationType === 'file') {
        params.documentId = annotationInfo.value.id;
        params.documentItemId = annotationInfo.value.imgId;
        apiPromise = getFileAnnocation(params);
        operationRecord(discussId.value, '文件—评论');
      } else if (annotationType === 'course') {
        apiPromise = getCourseAnnocation(params);
        operationRecord(discussId.value, '学程—评论');
      }
      apiPromise.then(function (res) {
        if (res.data.code === 0) {
          var annocations = res.data.data.annocations;
          state.list = (annocations || []).map(function (e) {
            return {
              id: e.id,
              head: e.annocationAvatar,
              name: e.annocationName,
              date: e.annocationTime,
              content: e.annocationContent,
              canDelete: e.annocationUserId === userId
            };
          });
        }
      });
    };

    // 点击删除
    var delClick = function delClick(type, id) {
      var dialog = DialogPlugin({
        header: '删除',
        body: '是否删除？',
        theme: 'danger',
        cancelBtn: '取消',
        confirmBtn: {
          content: '确认',
          theme: 'danger'
        },
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  if (type === 'list') {
                    delList();
                  } else if (type === 'single') {
                    delSingle(id);
                  }
                  dialog.destroy();
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          }));
          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    };

    // 删除评论列表
    var delList = function delList() {
      var params = {
        discussId: discussId.value,
        pointId: props.pointId
      };
      var apiPromise = null;
      if (annotationType === 'file') {
        params.documentId = annotationInfo.value.id;
        params.documentItemId = annotationInfo.value.imgId;
        apiPromise = delFileAnnocationList(params);
      } else if (annotationType === 'course') {
        params.courseResearchId = annotationInfo.value.courseId;
        apiPromise = delCourseAnnocationList(params);
      }
      apiPromise.then(function (res) {
        if (res.data.code === 0) {
          MessagePlugin.success('删除成功！');
          emit('close');
          emit('delPoint', props.pointId);
        }
      });
    };

    // 删除评论
    var delSingle = function delSingle(id) {
      var apiPromise = null;
      if (annotationType === 'file') {
        apiPromise = delFileAnnocation(discussId.value, id);
      } else if (annotationType === 'course') {
        apiPromise = delCourseAnnocation(discussId.value, id);
      }
      apiPromise.then(function (res) {
        if (res.data.code === 0) {
          MessagePlugin.success('删除成功！');
          getList();
        }
      });
    };

    /* 钩子 */
    onMounted(function () {
      getList();
    });
    return function (_ctx, _cache) {
      var _unref2;
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", {
        class: "annotation-list",
        style: _normalizeStyle({
          left: "".concat(props.x, "px"),
          top: "".concat(props.y, "px")
        })
      }, [!__props.readOnly ? (_openBlock(), _createElementBlock("div", _hoisted_1, [isMinePoint.value || isMineCanvas.value ? (_openBlock(), _createBlock(_component_svg_icon, {
        key: 0,
        class: "mr8 pointer",
        name: "delete-white",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return delClick('list');
        })
      })) : _createCommentVNode("", true), _createVNode(_component_svg_icon, {
        class: "pointer",
        name: "dialog-close-white",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return emit('close');
        })
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.list, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "item"
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createElementVNode("img", {
          class: "head",
          src: item.head || _unref(defaultAvatar),
          alt: ""
        }, null, 8, _hoisted_4), _createElementVNode("span", _hoisted_5, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(item.date), 1)]), !__props.readOnly && item.canDelete ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 0,
          class: "pointer",
          name: "delete-white",
          onClick: function onClick($event) {
            return delClick('single', item.id);
          }
        }, null, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.content), 1)])]);
      }), 128))]), !__props.readOnly ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("img", {
        class: "head",
        src: ((_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.avatar) || _unref(defaultAvatar),
        alt: ""
      }, null, 8, _hoisted_9), _createElementVNode("div", {
        ref_key: "textareaRef",
        ref: textareaRef,
        class: "textarea",
        placeholder: "请输入评论",
        contenteditable: "",
        onInput: handleInput
      }, null, 544), _createElementVNode("img", {
        class: "send-icon",
        src: _imports_0,
        alt: "",
        onClick: handleSend
      })])) : _createCommentVNode("", true)], 4);
    };
  }
};